import { Experiences } from '@/src/experiences'

export default Experiences.Notifications.Screens.Settings.Screen
